// Time during which the b2b onboarding button can be shown in the navbar
export const B2B_ONBOARDING_SHOW_BUTTON_INTERVAL = 60;
